import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchTransactions } from "../../features/transaction/transactionSlice";
import Transaction from "./Transaction";

const Transactions = () => {
    const dispatch = useDispatch();
    const { isLoading, isError, transactions } = useSelector(
        (state) => state.transaction
    );

    useEffect(() => {
        dispatch(fetchTransactions({ searchType: "all" }));
    }, [dispatch]);

    //slicing the last 5 transactions
    const startIndex = transactions?.length > 5 ? transactions?.length - 5 : 0;
    const last5transactions = transactions?.slice(startIndex);

    //decide what to render
    let content = null;

    if (isLoading) content = <p>Loading...</p>;

    if (!isLoading && isError)
        content = <p className="error">there was an error ocurred!</p>;

    if (!isLoading && !isError && transactions.length === 0)
        content = <p>No Data Found.</p>;

    if (!isLoading && !isError && transactions.length > 0) {
        content = last5transactions?.map((transaction) => (
            <Transaction key={transaction?.id} transaction={transaction} />
        ));
    }

    return (
        <>
            <p className="second_heading">Your Transactions:</p>

            <div className="conatiner_of_list_of_transactions">
                <ul>{content}</ul>
            </div>
            {transactions?.length > 5 && (
                <Link to={"/all-transactions"}>
                    <button type="button" className="view_all_btn">
                        View All
                    </button>
                </Link>
            )}
        </>
    );
};

export default Transactions;
